module.exports = __webpack_public_path__ + "static/media/banner3.9bffc437.jpg";